/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/triboro/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _triboro = __webpack_require__(1);

var _triboro2 = _interopRequireDefault(_triboro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_triboro2.default.init();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _header = __webpack_require__(2);

var _hero = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @NOTE: assumes jQuery is included by WP
var $ = jQuery;

var $window = $(window);

var Triboro = function () {
  function Triboro() {
    _classCallCheck(this, Triboro);
  }

  _createClass(Triboro, [{
    key: 'init',
    value: function init() {
      this.headerInit = new _header.header();
      this.heroInit = new _hero.hero();
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize(windowWidth) {
      // all methods that respond to window resize should be here

    }
  }, {
    key: 'onWindowScroll',
    value: function onWindowScroll() {
      // all methods that respond to window scroll should be here

    }
  }, {
    key: 'onWindowLoad',
    value: function onWindowLoad() {
      this.heroInit.onWindowLoad();
    }
  }]);

  return Triboro;
}();

var triboro = new Triboro();

var resizeThreshold;
$window.resize(function () {
  clearTimeout(resizeThreshold);
  resizeThreshold = setTimeout(function () {
    triboro.onWindowResize($window.width());
  }, 100);
});

$window.scroll(function () {
  triboro.onWindowScroll();
});

$(document).ready(function () {
  triboro.onWindowResize($window.width());
});

window.onload = function () {
  triboro.onWindowLoad();
};

exports.default = triboro;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(3);

Object.defineProperty(exports, 'header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_header).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @NOTE: assumes jQuery is included by WP
var $ = jQuery;

var header = function () {
	function header() {
		var _this = this;

		_classCallCheck(this, header);

		this.$mobileMenuButton = $('.mobile-menu-button');
		this.$mobileNavPanel = $('.mobile-nav-panel');
		this.$mobileCloseButton = $('.mobile-close-button');

		this.$mobileMenuButton.click(function (event) {
			_this.showMobileNavPanel();
		});

		this.$mobileCloseButton.click(function (event) {
			_this.hideMobileNavPanel();
		});
	}

	_createClass(header, [{
		key: 'showMobileNavPanel',
		value: function showMobileNavPanel() {
			this.$mobileNavPanel.addClass('show');
		}
	}, {
		key: 'hideMobileNavPanel',
		value: function hideMobileNavPanel() {
			this.$mobileNavPanel.removeClass('show');
		}
	}]);

	return header;
}();

exports.default = header;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hero = __webpack_require__(5);

Object.defineProperty(exports, 'hero', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hero).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// @NOTE: assumes jQuery is included by WP
var $ = jQuery;

var hero = function () {
	function hero() {
		var _this = this;

		_classCallCheck(this, hero);

		this.$hero = $('.hero');
		this.$whiteBox = $('.white-box');
		this.videoPlayButton = $('.video-play-button-container');
		this.$videoEmbedContainer = $('.video-embed-container');

		this.videoPlayButton.click(function (event) {
			_this.vimeoIframe = $('.hero iframe')[0];
			_this.vimeoPlayer = new Vimeo.Player(_this.vimeoIframe);
			_this.vimeoPlayer.play();

			_this.videoPlayButton.addClass('invisible');
			_this.$videoEmbedContainer.removeClass('invisible');
		});
	}

	_createClass(hero, [{
		key: 'onWindowLoad',
		value: function onWindowLoad() {
			var _this2 = this;

			this.$hero.removeClass('before-load');

			setTimeout(function () {
				_this2.$whiteBox.removeClass('before-load');
			}, 400);
		}
	}]);

	return hero;
}();

exports.default = hero;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/triboro.js